export const PARTNERS_EMAIL_TEMPLATE_ID = 139;
